import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { BehaviorSubject, Observable, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class OptionTypeService {
  private _options : BehaviorSubject<any> = new BehaviorSubject(null);
  private _optionDetails : BehaviorSubject<any> = new BehaviorSubject(null);


  /**
   * Constructor
   */
  constructor(private _httpClient: HttpClient) {
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------

  /**
   * Getter for data
   */
  get options$(): Observable<any> {
    return this._options.asObservable();
  }

  get optionDetails$(): Observable<any> {
    return this._optionDetails.asObservable();
  }


  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Get data
   */
  getOptions(pageNumber, pageSize): Observable<any> {

    let Params = new HttpParams()
    Params = Params.append('page', pageNumber);
    Params = Params.append('pageSize', pageSize);

    return this._httpClient.get<any>(`${environment.apiURL}/${environment.apiVersion}/Option/GetOptions`,{params: Params}).pipe(
      tap((response: any) => {
        this._options.next(response);
      }),
    );
  }

  getOptionsbyId(optionId): Observable<any> {
    return this._httpClient.get<any>(`${environment.apiURL}/${environment.apiVersion}/Option/GetOption/${optionId}`).pipe(
      tap((response: any) => {
        this._optionDetails.next(response);
      }),
    );
  }

  getOptionItems(mdOptionName: string): Observable<any> {
    let Params = new HttpParams()
    Params = Params.append('mdOptionName', mdOptionName);

    return this._httpClient.get<any>(`${environment.apiURL}/${environment.apiVersion}/Option/GetOptionItems`, {params: Params}).pipe(
      tap((response: any) => {
        return response
      }),
    );
  }

  // 
  // Metadata / option type
  // 

  createOption(optionBody : any): Observable<any> {
    return this._httpClient.post<any>(`${environment.apiURL}/${environment.apiVersion}/Option/CreateOption`,optionBody).pipe(
      tap((response: any) => {
        return response
      }),
    );
  } 

  updateOption(id: string, optionBody : any): Observable<any> {    
    return this._httpClient.put<any>(`${environment.apiURL}/${environment.apiVersion}/Option/UpdateOption/${id}`, optionBody).pipe(
      tap((response: any) => {
        return response
      }),
    );
  } 

  deleteOption(id: string): Observable<any> {    
    return this._httpClient.delete<any>(`${environment.apiURL}/${environment.apiVersion}/Option/DeleteOption/${id}`).pipe(
      tap((response: any) => {
        return response
      }),
    );
  } 

  createOptionItem(optionItemBody : any): Observable<any> {
    return this._httpClient.post<any>(`${environment.apiURL}/${environment.apiVersion}/Option/CreateOptionItem`,optionItemBody).pipe(
      tap((response: any) => {
        return response
      }),
    );
  } 

  updateOptionItem(id: string, optionItemBody : any): Observable<any> {    
    return this._httpClient.put<any>(`${environment.apiURL}/${environment.apiVersion}/Option/UpdateOptionItem/${id}`, optionItemBody).pipe(
      tap((response: any) => {
        return response
      }),
    );
  } 

  deleteOptionItem(id: string): Observable<any> {    
    return this._httpClient.delete<any>(`${environment.apiURL}/${environment.apiVersion}/Option/DeleteOptionItem/${id}`).pipe(
      tap((response: any) => {
        return response
      }),
    );
  } 

}
